import api from '../../../../api/api'
import url from '../../../../api/env'
import Utils from '../../../../utils/Utils'

const uploadProducts = async (file) =>
  api
    .post(url.stage.productsCsvImport, file)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const uploadSkus = async (file) =>
  api
    .post(url.stage.presentationSkuCsvImport, file)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const uploadDiscounts = async (file) =>
  api
    .post(url.stage.discountsCsvImport, file)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const uploadPresentations = async (file) =>
  api
    .post(url.stage.presentationsCsvImport, file)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const uploadPresentationDiscounts = async (file) =>
  api
    .post(url.stage.presentationsDiscountsCsvImport, file)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  uploadProducts,
  uploadSkus,
  uploadDiscounts,
  uploadPresentations,
  uploadPresentationDiscounts
}
